'use client';

import React, { useLayoutEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface Props extends React.HTMLAttributes<HTMLDivElement>
{
  animation: any;
  loop: boolean;
  autoPlay?: boolean;
}

export default function Animation({ id, className, animation, loop, autoPlay = true }: Props) {
  const [shouldDisplay, setShouldDisplay] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  // this solves the "failed loading animation data" error for some reason O_o
  useLayoutEffect(() => {
    if (containerRef.current && window.getComputedStyle(containerRef.current).display !== 'none')
    {
      setShouldDisplay(true);
    }
  }, [containerRef]);

  return (
    <div ref={ containerRef } className={ className }>{
      shouldDisplay && <DotLottieReact className={ 'w-full h-full' } src={ `/animations/${ animation }` } autoplay={ autoPlay } loop={ loop } width={ 1024} height={ 1024} />
    }</div>
  );
}
